<template>
    <div class="location-list">
        <div class="scrollable-y" ref="locationListItems">

            <div v-if="listIsEmpy()">
            <transition-group appear name="fade" mode="out-in" v-on:enter="enter">
                    <div v-for="(loca, index) in allLocations" :key="loca.id" @click="changeLocationStatus(loca, index)">
                        <LocationCard v-bind:loca="loca" :class="{disabled : !loca.opening_hours.open_now || !loca.active, winner: loca===getWinner}"></LocationCard>
                    </div>
            </transition-group>
            </div>
            <div v-else>
                <div class="location-empty">
                    Seems like nothing is here :/
                </div>
            </div>
        </div>
        <div class="location-box">
            <label>
                <input type="text" class="location-input" placeholder="Add Locations"
                       v-model="newLocation" @keyup.enter="addtoList">
            </label>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import LocationCard from "./LocationCard";

    export default {
        name: "LocationList",
        components: {LocationCard},
        data() {
            return {
                newLocation: "",
                isinelse: "",
                wowyea: null,
            }
        },
        methods: {
            ...mapGetters([
               "getLocationByIndex"
            ]),
            ...mapMutations([
                "addLocation"
            ]),
            ...mapActions([
                "disableLocationByIndex",
                "enableLocationByIndex"
            ]),
            scrollToEnd(container){
                container.scrollTop = container.scrollHeight;
            },
            changeLocationStatus(loca, index) {
                loca.active ? this.$store.dispatch('disableLocationByIndex',index) : this.$store.dispatch('enableLocationByIndex',index);
            },
            addtoList() {
                if (this.newLocation.trim().length !== 0) {
                    this.addLocation(this.newLocation);
                }
                this.newLocation = "";
            },
            listIsEmpy() {
                return this.allLocations && this.allLocations.length !== 0
            },
            enter() {
                this.scrollToEnd(this.$refs.locationListItems);
            },
        },
        computed: {
            ...mapGetters([
                "allLocations",
                "getWinner"
            ])
        }
    }
</script>

<style lang="scss">

    .location-box {
        padding-left: 24px;
        display: block;
        border-top: 1px solid #ddd;
    }

    .location-input {

        color: inherit;
        font-size: 15px;
        margin: 0 !important;
        padding: 0 !important;
        height: 48px;
        border: medium none;
        width: 100%;

        z-index: 2;
        vertical-align: top;
        transition-property: color;
        transition-duration: 0.3s;

        &:focus {
            outline: 0;
        }
    }


    .location-empty {
        display: flex;
        justify-content: center;
        position: relative;
        align-items: center;
        text-align: center;

        /*justify-content: space-between;*/
        animation-duration: 0.3s;


        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        /*background-color: #f6f6f6; !* Add a grey background color *!*/
        /*padding: 12px; !* Add some padding *!*/

        box-sizing: border-box;
        /*height: 50vh;*/
        padding: 100px 18px 100px 24px;
        flex-flow: column;

    }

    .location-list {
        flex: 1 1;
        padding-top: 1px;
        display: flex;
        flex-direction: column;
        text-align: left;
        white-space: normal;
        max-height: 100%;
    }

    .scrollable-y {
        outline-offset: -2px;
        overflow-y: auto;
        max-height: 100%;
    }

    .remove-location {
        cursor: pointer;
        margin-left: 14px;

        &hover {
            color: black;
        }
    }
    .winner {
        position: relative;
        z-index: 0;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    }

    .disabled {
        opacity: 0.4;
        z-index: 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }



</style>